<template>
  <VisaForm country="saudi_arabia" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <MedicalInsuranceIncludedAlert class="mt-3 mb-7" />
      <EntryFields v-model="form.entry" :date-hint="$tt('estimate_entry_in_half_year')" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>
    
    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes half-year-valid />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <AddressFields v-model="applicant.address" />
          <MaritalStatusSelect v-model="applicant.maritalStatus" class="mb-6" />
          <FormBlock>
            <AppRow>
              <OccupationStatus v-model="applicant.occupation" />
              <ReligionSelect v-model="applicant.religion" />
            </AppRow>
          </FormBlock>
          <GuardianPassportField
            v-if="!isAdult(applicant.passport.dateOfBirth)"
            v-model="applicant.guardianPassport"
          />
        </template>
      </ApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import { isAdult } from '~/helpers/date';
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>